const isAboveBreakpoint = (breakpoint) => {
    return !!matchesMediaQuery(breakpoint)
}

const moveImageEl = () => {
    const parentEl = document.querySelector('.oraOffer')
    const mainEl = document.querySelector('.oraOffer__main')
    const imageEl = document.querySelector('.js_oraOfferImage')

    if (isAboveBreakpoint(960)) {
        if (!mainEl.contains(imageEl)) {
            mainEl.prepend(imageEl)
        }
    } else {
        if (mainEl.contains(imageEl)) {
            parentEl.prepend(imageEl)
        }
    }
}

window.addEventListener('DOMContentLoaded', () => {
    moveImageEl()
})

window.addEventListener('resize', debouncer(() => {
    moveImageEl()
}))